import { createFileRoute } from '@tanstack/react-router'
import MaterialsRoot from '@/pages/materials'

export const Route = createFileRoute('/app/materials/$materialId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { materialId } = Route.useParams()
  return <MaterialsRoot materialId={materialId} />
}
